<template>
    <div>   
        <b-modal
            :title="titulo"  
            id="modalAto"
            v-model="showModal"
            scrollable
            size="xl"
            body-class="p-1"
            no-close-on-esc
            no-close-on-backdrop
            no-enforce-focus 
            hide-header-close
            >
            <!-- Define os campos do modal-->
            <form>
                <!-- Dados Edicao -->
                <b-card no-body class="p-2 mx-1 my-1">
                    <b-row>
                        <b-col class="col-11 col-md-4">
                        <label class="font-weight-bold">Edição:</label
                        ><label class="ml-1">{{edicao.numero_edicao }}</label>
                        </b-col>
                        <b-col class="col-11 col-md-4">
                        <label class="font-weight-bold">Tipo Edição:</label
                        ><label class="ml-1">{{
                            $helper.getTipoEdicao(edicao.tipo_edicao)
                        }}</label>
                        </b-col>
                        <b-col class="col-11 col-md-4">
                        <label class="font-weight-bold">Data Publicação:</label
                        ><label class="ml-1">
                            {{ $helper.formatData(edicao.dt_publicacao) }}</label
                        >
                        </b-col>
                    </b-row>
                </b-card>

                <!--Dados Ato -->
                <b-card                    
                    class="mx-1"                       
                >           
                    <alert                                         
                        :variant="alert.variant"            
                        dismissible
                        :mensagens="alert.mensagens"
                        :value="alert.exibir"
                        @input="alertDismissed">
                    </alert>                                
                    <b-row >                        
                        
                        <b-col class="col-4">
                            <b-form-group 
                                label="Categoria" 
                                label-size="sm">
                                    <b-form-select
                                        @change="alteraDados"                                                                                                                          
                                        :options="categoriaAto.options"
                                        v-model="atoLocal.categoria_ato_id"
                                        :disabled="acao == 'view'"
                                        aria-describedby="feedback_categoria_ato_id"
                                        :state="$helper.validarEstadoCampo(atoLocal.categoria_ato_id, acao)">
                                    </b-form-select>
                                    <b-form-invalid-feedback id="feedback_categoria_ato_id">Campo Obrigatório.</b-form-invalid-feedback>
                            </b-form-group>  
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group 
                                label="Orgão" 
                                label-size="sm">
                                <!-- DISABLED NÃO FUNCIONOU NO COMPONENT AUTOCOMPLETE -->
                                <autocomplete
                                    @keyup.native='alteraDados'
                                    :function="buscarOrgaos"
                                    key-text="sigla_nome_orgao"
                                    key-id="id"
                                    :active-first="false"
                                    v-model="atoLocal.orgao.sigla_nome_orgao"
                                    :allow-any="false"
                                    :min-search-size="2" 
                                    @selected="selecionaOrgao"
                                    size="sm"
                                    :disabled="acao == 'view'"
                                    :state="$helper.validarEstadoCampo(atoLocal.orgao.sigla_nome_orgao, acao)"
                                    feedback="feedback_sigle_nome_orgao"
                                    ref="autocompleteorgao">
                                </autocomplete>
                            </b-form-group>  
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col >
                            <b-form-group 
                                label="Título do Ato" 
                                label-size="sm">
                                <b-form-textarea
                                    @keyup.native='alteraDados'
                                    v-model="atoLocal.titulo_ato"                                     
                                    :disabled="acao == 'view'"                                    
                                    aria-describedby="feedback_titulo_ato"
                                    :state="$helper.validarEstadoCampo(atoLocal.titulo_ato, acao)"
                                    maxlength="500"
                                    :rows="4"
                                    :max-rows="4"
                                    no-resize>
                                </b-form-textarea>
                                <b-form-invalid-feedback id="feedback_titulo_ato">Campo Obrigatório.</b-form-invalid-feedback>
                            </b-form-group>  
                        </b-col>
                    </b-row>
                    <b-row>   
                        <b-col>
                        <b-form-group 
                                label="Conteúdo" 
                                label-size="sm">                        
                            <editor                                                                 
                                v-model="atoLocal.conteudo_html"                                
                                :disabled="acao == 'view'"                                 
                                :init="configEditorHTML"
                            />
                        </b-form-group>  
                        </b-col>
                    </b-row>    
                    <b-row>                           
                        <b-col class="text-right">
                            <b-btn 
                                class="mr-2"
                                variant="success" 
                                @click="salvar" 
                                v-if="acao != 'view'" >
                                <i class="fa fa-floppy-o pr-1"></i> Salvar Rascunho
                            </b-btn> 
                            <b-btn                        
                                variant="primary"
                                @click="publicar"
                                v-if="acao != 'view'"
                                :disabled="formAlterado || atoLocal.id == null"
                            >
                                <i class="fa fa-cloud-upload pr-1"></i> Publicar
                            </b-btn>
                        </b-col>
                    </b-row>
                </b-card> 

                <!-- Anexos -->     
                <h6 class="mt-3 ml-2 font-weight-bold">Anexos</h6>
                <b-card
                    class="mx-1 my-1"    
                > 
                    <anexoato :idAto="atoLocal.id" :acao="acao"> </anexoato> 
                </b-card>   

            </form>

            <template v-slot:modal-footer>
                <b-btn variant="danger" @click="sair">
                <i class="fa fa-sign-out pr-1"></i> Sair
                </b-btn>
            </template>
        </b-modal>         
                                                
    </div>
</template>

<script>

import "tinymce/tinymce.min.js"
import "tinymce/themes/silver/theme.min.js"
import "tinymce/models/dom/model.min.js"
import "tinymce/icons/default/icons.min.js"
import "tinymce/plugins/lists/plugin.min.js"
import "tinymce/plugins/autolink/plugin.min.js"
import "tinymce/plugins/link/plugin.min.js"
import "tinymce/plugins/preview/plugin.min.js"
import "tinymce/plugins/searchreplace/plugin.min.js"
import "tinymce/plugins/table/plugin.min.js"
import "tinymce/plugins/wordcount/plugin.min.js"
import "tinymce/plugins/help/js/i18n/keynav/pt_BR.js"



import Alert from '../../../models/Alert';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import  autocomplete  from "../../../components/Autocomplete";
import Ato from '../../../models/Ato';
import Edicao from "../../../models/Edicao";
import Editor from '@tinymce/tinymce-vue';
import anexoato from "./../anexoAto/anexoAto";
import Orgao from '../../../models/Orgao';

export default {

    components: {
        autocomplete,
        'editor': Editor,
        anexoato
    },

    mixins: [validationMixin],

    props: {  
        edicao: { type: Edicao },
        idAto: { type: Number },          
        exibirModal: { type: Boolean, default: false },
        acao: { type: String, default: "" },
    },

    computed:{
        variantIconeArquivo(){
            return this.atoLocal.ato_documento_id  == null ? 'outline-secundary' : 'outline-primary';
        }
    },

    data(){
        return { 
            titulo: 'Ato',         
            atoLocal: new Ato(),               

            categoriaAto:{
                options:[]
            },

            alert: new Alert(),
            showModal: false,
            formAlterado:false,
            extPermitidasArquivoConteudoAto: [".docx", ".doc", ".rtf"], 

            configEditorHTML: {                               
                language: 'pt_BR',
                base_url: '/js/tinymce',       
                height: 550,
                menubar: false,
                paste_retain_style_properties: 'all',
                branding: false,                               
                plugins: [
                    "lists", "autolink", "link", "preview",
                    "searchreplace", "table", "paste", "wordcount"
                ],
                toolbar: [
                    'bold italic underline strikethrough fontfamily blocks fontsize forecolor backcolor bullist numlist subscript superscript removeformat',
                    'alignleft aligncenter alignright alignjustify outdent indent table link undo redo preview customUploadWord'
                ], 
                setup: (ed) => {
                    ed.on('keydown', (event) => {    
                        this.alteraDados();                                                                                    
                        if (event.keyCode == 9) { // tab pressed                                                
                            if (event.shiftKey) {
                                ed.execCommand('Outdent');
                            }
                            else {
                                ed.execCommand('Indent');
                            }

                            event.preventDefault();
                            return false;
                        }
                    });                    


                    ed.ui.registry.addButton('customUploadWord', {
                        icon: 'upload',
                        tooltip: 'Upload Word',
                        onAction: () => {        
                            var input = document.createElement('input');
                            input.setAttribute('type', 'file');
                            input.setAttribute('accept', this.extPermitidasArquivoConteudoAto)
                            input.onchange = (e) => {                                                                                       
                                var inputFile = e.target.files[0];                                                                
                                this.importarConteudoHTMLDeDocumentoWord(inputFile);                                         
                            };                            

                            input.click();
                        }      
                    });
                }
            }                  
        }
    },

    validations: {
        categoria_ato_id: {
            required,
        },
        sigla_nome_orgao: {
            required,
        },
        titulo_ato: {
            required,
        }
    },
    
    methods: {

        alteraDados(){
            this.formAlterado = true;
        },

        alertDismissed(){           
            this.alert= new Alert();
        },
        
        obter(id){                 
            return this.$api.ato.obter(id)
                .then(response => {                                            
                    this.atoLocal = new Ato(response.data.data);                                                                                                                                   
                })
                .catch(error => {
                   this.$helper.showAlert(this.alert, 
                                          this.$constantes.alert.variants.DANGER,
                                          error.response.data.errors); 
                });                             
        },

        buscarCategoriasAto(){                                                          
            this.$api.categoriaAto.listar()
                .then(response => {    
                    this.categoriaAto.options = [];                                                                                
                    response.data.data.forEach(element => {                                                                                    
                       let option = {
                           value: element.id,
                           text: element.nome_categoria,
                           disabled: !element.ind_ativo 
                       };                       
                       this.categoriaAto.options.push(option);
                    });  
                    
                })
                .catch(error => {
                    this.$helper.showAlert(this.alert, 
                                           this.$constantes.alert.variants.DANGER,
                                           error.response.data.errors);     
                });       
        },

        buscarOrgaos(siglaNome){                 
            let parametros = {
               sigla_nome: siglaNome,
               ind_favorito_dom: true    
            };    

            return this.$api.orgao.buscar(parametros)
                       .then(response => {                       
                            response.data.data.forEach(element => { 
                                element.sigla_nome_orgao =  element.sigla_orgao + ' - ' + element.nome_orgao;                                                  
                            });  
                          
                            return response;
                        });
        },               

        
        async importarConteudoHTMLDeDocumentoWord(arquivo){
            
            if(!this.$helper.validaExtensaoArquivo(arquivo.name, this.extPermitidasArquivoConteudoAto)){
                this.$helper.showAlert(this.alert, 
                                       this.$constantes.alert.variants.WARNING,
                                      'Extensão do arquivo não suportada. Escolha arquivos com as extensões: ' +  this.extPermitidasArquivoConteudoAto.toString());                  
                this.$helper.scrollModalToTop();
                return;                    
            }


            let params = {}
            var arquivoBase64 = null;
            
            await this.$helper.convertToBase64(arquivo)
            .then(response => {                    
                arquivoBase64 = response;      
            })              
            .catch(error => {           
                this.alert = {
                    variant: 'danger',
                    mensagens: 'Erro ao converter anexo para base64: ' + error.response.data.errors,
                    exibir:true                     
                };    
            });  
            
            params.arquivo = arquivoBase64;
            await this.$api.documento.converterWordParaHTML(params)
                .then(response => {                    
                    if(response.status == 200){   
                       this.atoLocal.conteudo_html = response.data.data;
                    }             
                })
                .catch(error => {             
                    this.$helper.showAlert(this.alert, 
                                           this.$constantes.alert.variants.DANGER,
                                           error.response.data.errors);                                                              
                });                    
        },

        incluir(){                   
            this.$api.ato.incluir(this.edicao.id, this.atoLocal)
                .then(response => {                    
                    if(response.status == 200 || response.status == 201){                           
                        this.atoLocal = new Ato(response.data.data);                                       
                        this.formAlterado = false;
                        this.$helper.showAlert(this.alert, 
                                               this.$constantes.alert.variants.SUCCESS,
                                               'Registro inserido com sucesso!');                                                                                                           
                    }             
                })
                .catch(error => {             
                    this.$helper.showAlert(this.alert, 
                                           this.$constantes.alert.variants.DANGER,
                                           error.response.data.errors);                                                                
                });  
        },

        editar(){               
            this.$api.ato.editar(this.atoLocal.id, this.atoLocal)
                .then(response => {                    
                    if(response.status == 200 || response.status == 201){                                                                                             
                        this.atoLocal = new Ato(response.data.data);
                        this.formAlterado = false;
                        this.$helper.showAlert(this.alert, 
                                               this.$constantes.alert.variants.SUCCESS,
                                               'Registro atualizado com sucesso!');                                                                                                        
                    }
                })
                .catch(error => {                     
                    this.$helper.showAlert(this.alert, 
                                           this.$constantes.alert.variants.DANGER,
                                           error.response.data.errors);                                                            
                });   
        },

        salvar(){    
            if(this.validaCamposObrigatoriosPreenchidos()){ 
                let ato = new Ato(this.atoLocal);
                delete ato.documento_ato;
                delete ato.arquivo_ato;

                if (ato.id == null){        
                    this.incluir();                                                        
                }else{
                    this.editar();
                }                

            }else{
                this.$helper.showAlert(this.alert, 
                                       this.$constantes.alert.variants.DANGER,
                                       'Existe(m) campo(s) obrigatório(s) não preenchido(s).');                   
            } 
            
            this.$helper.scrollModalToTop();
        },

        selecionaOrgao(orgao){            
           this.atoLocal.orgao_id = orgao.id;                                            
           this.atoLocal.orgao.sigla_nome_orgao =  orgao.sigla_nome_orgao;            
        },

        validaCamposObrigatoriosPreenchidos() {
            return (this.atoLocal.categoria_ato_id && 
                    this.atoLocal.orgao.sigla_nome_orgao && 
                    this.atoLocal.titulo_ato &&
                    this.atoLocal.conteudo_html);  
        },

        publicar() {
            this.$api.ato
                .publicar(this.atoLocal.id)
                .then((response) => {
                    if (response.status == 200) {
                        //Solicitacao da GDOF: Apos publicar o ato deve ser limpado todos os campos para insercao de um novo ato.
                        //Exceto o campo de orgao que deve permancer preenchido com o orgao do ato anterior
                        this.atoLocal = new Ato();                  
                        this.atoLocal.orgao_id  = response.data.data.orgao_id;
                        this.atoLocal.orgao = new Orgao(response.data.data.orgao);
                        
                        //Apaga conteudo do editor HTML. Mesmo 'this.atoLocal.conteudo_html' sendo setado para null nao estava apagando o conteudo na tela
                        window.tinyMCE.activeEditor.setContent('');
                                                                        
                        this.$helper.showAlert(this.alert,
                                               this.$constantes.alert.variants.SUCCESS,
                                               "Ato publicado com sucesso!");
                    }
                })
                .catch((err) => {
                    this.$helper.showAlert(
                        this.alert,
                        this.$constantes.alert.variants.DANGER,
                        err.response.data.errors
                    );
            });

            this.$helper.scrollModalToTop();
        },

        sair() {
            if (this.formAlterado) {
                this.$helper
                .confirmaVoltar(
                    this,
                    "Existem alterações que não foram salvas. Deseja mesmo sair ?"
                )
                .then((confirmado) => {
                    if (confirmado) {
                    this.showModal = false;
                    }
                });
            } else {
                this.showModal = false;
            }
        },
        
    },

    created() {
        this.showModal = this.exibirModal;
    },

    async mounted(){
        if(this.acao == 'new'){
            this.atoLocal = new Ato();
        }else{
            await this.obter(this.idAto);
        }
                
        this.buscarCategoriasAto();                      
    },

    watch: {
        showModal: function () {
            this.$emit("update:exibirModal", this.showModal);
        },
    },

}
</script>
<style scoped>
    .fa-trash {
        color: #dc3545;
    }

</style>

